module.exports = __webpack_public_path__ + "img/deces.ea14bd9c.jpg";